module.exports = {"name":"Embeddable Card","what":{"description":"Functionality to make the course cards embeddable on external platforms","requirements":["General website embeddability","Socials embeddability"]},"planning":{"due":"July 15","completed":false,"started":false,"duration":"40 hours"},"who":{"description":"An enthusiast with advanced JavaScript knowledge","level":"expert","skills":["JavaScript","React","HTML","CSS"],"team":["Jan Hein Hoogstad"]},"why":"Ability to communicate knowledge through any desired online platform"}


//////////////////
// WEBPACK FOOTER
// ./src/features/embeddable-widget.yaml
// module id = 517
// module chunks = 0